export type InstructionNotice = {
  departmentCode: string;
  startPlanDate: string;
  systemDate: string;
  updatedAt: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseInstructionNotice(value: any): InstructionNotice {
  return {
    departmentCode: value.DepartmentCode,
    startPlanDate: value.StartPlanDate,
    systemDate: value.SystemDate,
    updatedAt: value.updatedAt,
  };
}
